export const TestimonialSideCarousel = (function () {
  let swiperInstance, prevButton, nextButton = null;
  let SELECTORS = null; // Declare SELECTORS as null initially

  function initSwiper() {
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    prevButton = document.querySelector(SELECTORS.prevButton);
    nextButton = document.querySelector(SELECTORS.nextButton);

    if (!swiperWrapper || !prevButton || !nextButton) {
      console.error('Required elements not found');
      return null;
    } 

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: SELECTORS.nextButton,
        prevEl: SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

		swiperInstance = swiper;

    // Set initial state of buttons
    updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', function () {
      updateButtonsState();
    });

    return swiper;
  }

  // Function to update button states
  function updateButtonsState() {
  	if (!prevButton || !nextButton) return;
    
    prevButton.style.opacity = swiperInstance.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto'; 

		nextButton.style.opacity = swiperInstance.isEnd ? '0.5' : '1';
    nextButton.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
  }

  // Public methods
  return {
    init: function(selectors) {
      SELECTORS = selectors; // Assign selectors to the SELECTORS variable
     	document.addEventListener('DOMContentLoaded', function() {
        // Initialize swiper
        initSwiper();
			});
    }
  };
})();
